import { useCallback } from 'react'
import { Location } from 'history'
import { useHistory, useLocation } from 'react-router-dom'

export type HistoryWithStateLocationState = {
  from?: Location<HistoryWithStateLocationState>
  prevPath?: string
}

export const useHistoryWithState = () => {
  const history = useHistory<HistoryWithStateLocationState>()
  const location = useLocation<HistoryWithStateLocationState>()

  const push = useCallback<(typeof history)['push']>(
    pushLocation => {
      history.push(pushLocation, { from: location })
    },
    [history, location],
  )

  const goBack = useCallback(
    (defaultRoute?: string) => {
      if (location?.state?.from || !defaultRoute) {
        history.goBack()
      } else {
        history.push(defaultRoute)
      }
    },
    [history, location?.state?.from],
  )

  return {
    ...history,
    goBack,
    push,
  }
}
